import { useSqwLayout } from '../SqwLayoutContext';
import { S } from './Branding.styles';
import type { BrandingProps } from './Branding.types';

export const Branding = ({ logo, children, ...otherProps }: BrandingProps) => {
  const { isSidebarCollapsed } = useSqwLayout();

  return (
    <S.Container isSidebarCollapsed={isSidebarCollapsed} {...otherProps}>
      {children ? (
        <>
          <S.ToggleWrapper>{children}</S.ToggleWrapper>
          {logo && <S.LogoWrapper>{logo}</S.LogoWrapper>}
          <S.Spacer />
        </>
      ) : (
        logo && <S.LogoWrapper>{logo}</S.LogoWrapper>
      )}
    </S.Container>
  );
};
